module.exports = __webpack_public_path__ + "static/bgHeroBlog-d69d47e925a4225c37f8534e69b4959f.jpg";